/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendCurrencyItemDto } from '../models/backend-currency-item-dto';
import { BackendIndustryItemDto } from '../models/backend-industry-item-dto';
import { listCategoriesCategoriesGet } from '../fn/references/list-categories-categories-get';
import { ListCategoriesCategoriesGet$Params } from '../fn/references/list-categories-categories-get';
import { listCurrenciesCurrenciesGet } from '../fn/references/list-currencies-currencies-get';
import { ListCurrenciesCurrenciesGet$Params } from '../fn/references/list-currencies-currencies-get';
import { listIndustriesIndustriesGet } from '../fn/references/list-industries-industries-get';
import { ListIndustriesIndustriesGet$Params } from '../fn/references/list-industries-industries-get';

@Injectable({ providedIn: 'root' })
export class BackendApiReferencesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listIndustriesIndustriesGet()` */
  static readonly ListIndustriesIndustriesGetPath = '/industries';

  /**
   * Справочник отраслей.
   *
   * Все строки `projects_industry`. Поскольку `projects_project.category` пока пуст, на этапе 3 «категория» = `industry_main_id` → `projects_industry`.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listIndustriesIndustriesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  listIndustriesIndustriesGet$Response(
    params?: ListIndustriesIndustriesGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendIndustryItemDto>>> {
    return listIndustriesIndustriesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Справочник отраслей.
   *
   * Все строки `projects_industry`. Поскольку `projects_project.category` пока пуст, на этапе 3 «категория» = `industry_main_id` → `projects_industry`.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listIndustriesIndustriesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listIndustriesIndustriesGet(
    params?: ListIndustriesIndustriesGet$Params,
    context?: HttpContext,
  ): Observable<Array<BackendIndustryItemDto>> {
    return this.listIndustriesIndustriesGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendIndustryItemDto>>): Array<BackendIndustryItemDto> => r.body),
    );
  }

  /** Path part for operation `listCurrenciesCurrenciesGet()` */
  static readonly ListCurrenciesCurrenciesGetPath = '/currencies';

  /**
   * Справочник валют.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listCurrenciesCurrenciesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCurrenciesCurrenciesGet$Response(
    params?: ListCurrenciesCurrenciesGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendCurrencyItemDto>>> {
    return listCurrenciesCurrenciesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Справочник валют.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listCurrenciesCurrenciesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCurrenciesCurrenciesGet(
    params?: ListCurrenciesCurrenciesGet$Params,
    context?: HttpContext,
  ): Observable<Array<BackendCurrencyItemDto>> {
    return this.listCurrenciesCurrenciesGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendCurrencyItemDto>>): Array<BackendCurrencyItemDto> => r.body),
    );
  }

  /** Path part for operation `listCategoriesCategoriesGet()` */
  static readonly ListCategoriesCategoriesGetPath = '/categories';

  /**
   * Список заполненных значений `projects_project.category`.
   *
   * Уникальные непустые значения `category` в активных проектах. Сейчас вернёт пустой список — колонка во всех 78 проектах БД пуста (это нормально, пока клиент не начал её заполнять).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listCategoriesCategoriesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCategoriesCategoriesGet$Response(
    params?: ListCategoriesCategoriesGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<string>>> {
    return listCategoriesCategoriesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Список заполненных значений `projects_project.category`.
   *
   * Уникальные непустые значения `category` в активных проектах. Сейчас вернёт пустой список — колонка во всех 78 проектах БД пуста (это нормально, пока клиент не начал её заполнять).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listCategoriesCategoriesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCategoriesCategoriesGet(
    params?: ListCategoriesCategoriesGet$Params,
    context?: HttpContext,
  ): Observable<Array<string>> {
    return this.listCategoriesCategoriesGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<string>>): Array<string> => r.body),
    );
  }
}
